import React from 'react';
import PropTypes from 'prop-types';
import Button from 'components/shared/button/Button';
import DatetimePicker from 'components/shared/datetime-picker/DatetimePicker';
import './ReportFilter.css';
import CheckBox from 'components/shared/checkbox/CheckBox';

export default function ReportFilter(props) {
  const handleStartDateChange = (value) => {
    if (props.onStartDateChange) {
      props.onStartDateChange(value);
    }
  };

  const handleEndDateChange = (value) => {
    if (props.onEndDateChange) {
      props.onEndDateChange(value);
    }
  };

  const handleExport = () => {
    if (props.onExport) {
      props.onExport();
    }
  };

  const handleSearchClick = () => {
    if (props.onSearchClick) {
      props.onSearchClick();
    }
  };

  const handleSelectAllCheck = () => {
    if (props.onSelectAllCheck) {
      props.onSelectAllCheck();
    }
  };

  let buttonLabel;
  if (props.searching) {
    buttonLabel = 'Searching...';
  } else {
    buttonLabel = 'Search';
  }
  return (
    <div className="report-filter">
      <CheckBox
        checked={props.selectAllChecked}
        className="check-select-all"
        readOnly={props.selectAllDisabled}
        onChange={handleSelectAllCheck}
      />
      <DatetimePicker
        placeholder="Start Date"
        value={props.startDate}
        onChange={(value) => handleStartDateChange(value)}
      />
      <DatetimePicker
        placeholder="End Date"
        value={props.endDate}
        onChange={(value) => handleEndDateChange(value)}
      />
      {props.extraFilters.map((filter, i) => (
        <div className="extra-filter" key={i}>
          {filter}
        </div>
      ))}
      <Button
        className="button-orange"
        disabled={props.searching}
        label={buttonLabel}
        onClick={handleSearchClick}
      />
      <Button
        className="button-orange export-button"
        disabled={props.exportButtonDisabled}
        label="Export to Excel"
        onClick={handleExport}
      />
    </div>
  );
}

ReportFilter.propTypes = {
  exportButtonDisabled: PropTypes.bool,
  selectAllChecked: PropTypes.bool,
  selectAllDisabled: PropTypes.bool,
  onStartDateChange: PropTypes.func,
  onEndDateChange: PropTypes.func,
  onExport: PropTypes.func,
  onSearchClick: PropTypes.func,
  onSelectAllCheck: PropTypes.func,
  extraFilters: PropTypes.array,
};

ReportFilter.defaultProps = {
  exportButtonDisabled: true,
  selectAllChecked: false,
  selectAllDisabled: false,
  extraFilters: [],
};



// WEBPACK FOOTER //
// ./src/components/admin/reports/ReportFilter.js